<template>
  <div>
    <el-form class="editForm" :model="formData" :rules="formValidateRule" :label-width="labelWidth" ref="form">
      <el-row v-for="(row, index) in formatedEntityPropertys" :key="'row' + index">
        <el-col v-for="(item, itemIndex) in row" :key="'col' + itemIndex" :span="(24 / (colsOfRow * 2)) * ((item.editColspan || item.colspan) + 1)">
          <el-form-item :label="item.chineseName" :prop="item.name" :key="'form-item' + itemIndex">
            <!-- 普通文本 -->
            <el-input v-if="VType(item, '01')" :placeholder="item.placeholder" style="min-width:150px;" v-model="formData[item.name]"></el-input>
            <!-- 整数 -->
            <el-input v-else-if="VType(item, '02')" :placeholder="item.placeholder" style="min-width:150px;" v-model="formData[item.name]"></el-input>
            <!-- 日期 -->
            <el-date-picker v-else-if="VType(item, '03')" v-model="formData[item.name]" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
            <!-- 日期时间 -->
            <el-date-picker v-else-if="VType(item, '04')" v-model="formData[item.name]" type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
            <!-- 列表型字典 -->
            <dictionary v-else-if="VType(item, '05')" :dicName="item.dicName" :initValue="(formData[item.name] || '') + ';' + (formData[item.name + '_name'] || '')" v-model="formData[item.name]"></dictionary>
            <!-- 两位小数 -->
            <el-input v-else-if="VType(item, '06')" :placeholder="item.placeholder" style="min-width:150px;" v-model="formData[item.name]"></el-input>
            <!-- 四位小数 -->
            <el-input v-else-if="VType(item, '07')" :placeholder="item.placeholder" style="min-width:150px;" v-model="formData[item.name]"></el-input>
            <!-- 六位小数 -->
            <el-input v-else-if="VType(item, '08')" :placeholder="item.placeholder" style="min-width:150px;" v-model="formData[item.name]"></el-input>
            <!-- 多选列表形字典 -->
            <check-dictionary v-else-if="VType(item, '09')" :dicName="item.dicName" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" :dictionaryFilterScript="item.dictionaryFilterScript" v-model="formData[item.name]" :isCheckAll="item.isCheckAll"></check-dictionary>
            <!-- 列表字典引用 -->
            <dictionary v-else-if="VType(item, '10')" :dicName="item.dicName" :isQuote="true" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" :dictionaryFilterScript="item.dictionaryFilterScript" :initValue="(formData[item.name] || '') + ';' + (formData[item.name + '_name'] || '')" v-model="formData[item.name]"></dictionary>
            <!-- 多选列表形字典引用 -->
            <check-dictionary v-else-if="VType(item, '11')" :dicName="item.dicName" :isQuote="true" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" :dictionaryFilterScript="item.dictionaryFilterScript" v-model="formData[item.name]" :isCheckAll="item.isCheckAll"></check-dictionary>
            <!--树形字典-->
            <tree-dictionary v-else-if="VType(item, '12')" :dicName="item.dicName" :multiple="false" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" :dictionaryFilterScript="item.dictionaryFilterScript" :onlyLeaf="item.onlyLeaf || false" :disabled="item.disabled" :clearable="item.clearable" :initValue="formData[item.name] || ''" :topDm="item.topDm" :removedDm="item.removedDm" v-model="formData[item.name]" :isSimpleValue="item.isSimpleValue" :filterDm="item.filterDm" :checkStrictly="item.checkStrictly" :allDmList="item.allDmList" placeholder="请选择" :isShowValue="item.isShowValue" :label="formData[item.name + '_name']"></tree-dictionary>
            <!--多选树形字典-->
            <tree-dictionary v-else-if="VType(item, '13')" :dicName="item.dicName" :multiple="true" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" :dictionaryFilterScript="item.dictionaryFilterScript" :onlyLeaf="item.onlyLeaf || false" :disabled="item.disabled" :clearable="item.clearable" :initValue="formData[item.name] || ''" :topDm="item.topDm" :removedDm="item.removedDm" v-model="formData[item.name]" :isSimpleValue="item.isSimpleValue" :filterDm="item.filterDm" :checkStrictly="item.checkStrictly" :allDmList="item.allDmList" placeholder="请选择" :isShowValue="item.isShowValue" :label="formData[item.name + '_name']"></tree-dictionary>
            <!--树形字典引用-->
            <tree-dictionary v-else-if="VType(item, '14')" :dicName="item.dicName" :multiple="false" :isQuote="true" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" :dictionaryFilterScript="item.dictionaryFilterScript" :onlyLeaf="item.onlyLeaf || false" :disabled="item.disabled" :clearable="item.clearable" :initValue="formData[item.name] || ''" :topDm="item.topDm" :removedDm="item.removedDm" v-model="formData[item.name]" :isSimpleValue="item.isSimpleValue" :filterDm="item.filterDm" :checkStrictly="item.checkStrictly" :allDmList="item.allDmList" placeholder="请选择" :isShowValue="item.isShowValue" :label="formData[item.name + '_name']"></tree-dictionary>
            <!--多选树形字典引用-->
            <tree-dictionary v-else-if="VType(item, '15')" :dicName="item.dicName" :multiple="true" :isQuote="true" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" :dictionaryFilterScript="item.dictionaryFilterScript" :onlyLeaf="item.onlyLeaf || false" :disabled="item.disabled" :clearable="item.clearable" :initValue="formData[item.name] || ''" :topDm="item.topDm" :removedDm="item.removedDm" v-model="formData[item.name]" :isSimpleValue="item.isSimpleValue" :filterDm="item.filterDm" :checkStrictly="item.checkStrictly" :allDmList="item.allDmList" placeholder="请选择" :isShowValue="item.isShowValue" :label="formData[item.name + '_name']"></tree-dictionary>
            <!-- 多行文本 -->
            <el-input v-else-if="VType(item, '16')" :placeholder="item.placeholder" :rows="item.rows || 3" style="min-width:150px;" v-model="formData[item.name]"></el-input>
            <!-- 选择文件 -->
            <div v-else-if="VType(item, '17')">文件输入，待添加功能</div>
            <!-- 文件添加 -->
            <div v-else-if="VType(item, '18')">文件添加，待添加功能</div>
            <!-- 图片添加 -->
            <div v-else-if="VType(item, '19')">图片添加，待添加功能</div>
            <!-- 反向列表型字典 -->
            <div v-else-if="VType(item, '20')">反向列表型字典，待添加</div>
            <!-- 反向列表型字典引用 -->
            <div v-else-if="VType(item, '21')">反向列表型字典引用，待添加</div>
            <!-- 时间戳 -->
            <div v-else-if="VType(item, '22')">时间戳</div>
            <!-- 地理点 -->
            <div v-else-if="VType(item, '23')">地理点</div>
            <!-- 人脸 -->
            <div v-else-if="VType(item, '24')">人脸</div>
            <!--多项checkBox列表-->
            <el-checkbox-group v-else-if="VType(item, '25')" style="min-width:150px;" v-model="formData[item.name]">
              <el-checkbox v-for="option in item.options" :key="option.value" :label="option.value">{{ option.label }}</el-checkbox>
            </el-checkbox-group>
            <!--单选列型字典-->
            <radio-dictionary v-else-if="VType(item, '26')" :dicName="item.dicName" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" :dictionaryFilterScript="item.dictionaryFilterScript" v-model="formData[item.name]"></radio-dictionary>
            <!--两级树形字典-->
            <tree-dictionary v-else-if="VType(item, '27')" :dicName="item.dicName" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" :dictionaryFilterScript="item.dictionaryFilterScript" :multiple="item.multiple || false" :onlyLeaf="item.onlyLeaf || false" :disabled="item.disabled" :clearable="item.clearable" :initValue="formData[item.name] || ''" :topDm="item.topDm" :removedDm="item.removedDm" v-model="formData[item.name]" :isSimpleValue="item.isSimpleValue" :filterDm="item.filterDm" :checkStrictly="item.checkStrictly" :allDmList="item.allDmList" placeholder="请选择" :isShowValue="item.isShowValue" :label="formData[item.name + '_name']"></tree-dictionary>
            <!--三级树形字典-->
            <tree-dictionary v-else-if="VType(item, '28')" :dicName="item.dicName" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" :dictionaryFilterScript="item.dictionaryFilterScript" :multiple="item.multiple || false" :onlyLeaf="item.onlyLeaf || false" :disabled="item.disabled" :clearable="item.clearable" :initValue="formData[item.name] || ''" :topDm="item.topDm" :removedDm="item.removedDm" v-model="formData[item.name]" :isSimpleValue="item.isSimpleValue" :filterDm="item.filterDm" :checkStrictly="item.checkStrictly" :allDmList="item.allDmList" placeholder="请选择" :isShowValue="item.isShowValue" :label="formData[item.name + '_name']"></tree-dictionary>
            <!--单选radio选项-->
            <el-radio-group v-else-if="VType(item, '29')" style="min-width:150px;" v-model="formData[item.name]" @change="$emit('change')">
              <el-radio v-for="option in item.options" :key="option.value" :label="option.value">{{ option.label }}</el-radio>
            </el-radio-group>
            <!-- 单选select选择框 -->
            <!-- <el-select v-else-if="VType(item, '29')" placeholder="请选择" style="min-width:150px;" v-model="formData[item.name]">
              <el-option v-for="option in item.options" :key="option.value" :label="option.label" :value="option.value"></el-option>
            </el-select>-->
            <div v-else-if="VType(item, '30')">分组标签无数输入，待拓展</div>
            <!--选择框字典，下拉全部显示-->
            <select-dictionary v-else-if="VType(item, '31')" :dicName="item.dicName" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" :dictionaryFilterScript="item.dictionaryFilterScript" v-model="formData[item.name]"></select-dictionary>
            <!-- 时间选择器组件 -->
            <tm-date-picker v-else-if="VType(item, '50')" v-model="formData[item.name]" :type="item.type" :clearable="item.clearable"></tm-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import Dictionary from '@/components/dictionary/dictionary'
import TreeDictionary from '@/components/dictionary/tree-dictionary'
import SelectDictionary from '@/components/dictionary/select-dictionary'
import CheckDictionary from '@/components/dictionary/checkbox-dictionary'
import RadioDictionary from '@/components/dictionary/radio-dictionary'
// import CheckboxDictionary from '@/components/dictionary/checkbox-dictionary'

export default {
  name: 'EditFormBuilder',
  components: {
    Dictionary,
    TreeDictionary,
    SelectDictionary,
    CheckDictionary,
    RadioDictionary
    // CheckboxDictionary
  },
  props: {
    labelWidth: {
      default: '150px'
    },
    entityPropertys: {
      type: Array,
      default: function() {
        return []
      }
    },
    formData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    colsOfRow: {
      type: Number,
      default: 2
    },
    formStatus: {
      type: Number,
      default: 1
    }
  },

  computed: {
    formatedEntityPropertys: function() {
      let cols = 0
      const newEntityPropertys = this.entityPropertys
        .filter(item => {
          if (item.appearPlace.indexOf('01') !== -1) {
            return true
          } else {
            return false
          }
        })
        .map((item, index) => {
          if (cols % (this.colsOfRow * 2) === 0) {
            item.rowBegin = true
          } else {
            item.rowBegin = false
          }
          cols = cols + item.colspan + 1
          return item
        })
      const formatedEntityPropertys = []
      let newRowItems = [newEntityPropertys[0]]
      formatedEntityPropertys.push(newRowItems)
      for (let i = 1; i < newEntityPropertys.length; i++) {
        if (newEntityPropertys[i].rowBegin) {
          newRowItems = [newEntityPropertys[i]]
          formatedEntityPropertys.push(newRowItems)
        } else {
          newRowItems.push(newEntityPropertys[i])
        }
      }
      return formatedEntityPropertys
    },
    formValidateRule() {
      //验证规则持续添加中
      var formValidateRuleData = {}
      this.entityPropertys.forEach(property => {
        var inputValidateType = property.inputValidateType
        if (inputValidateType) {
          var rules = []
          var inputValidateTypes = inputValidateType.split(',')
          inputValidateTypes.forEach(element => {
            if (element === '01') {
              rules.push({ required: true, message: '必须输入', trigger: 'blur' })
            } else if (element === '02' || element === '03') {
              rules.push({ type: 'date', required: true, message: '请选择日期', trigger: 'change' })
            } else if (element === '04') {
              rules.push({ message: '请填写整数', validator: this.regularCheck(/^\+?[1-9][0-9]*$/) })
            } else if (element === '05') {
              rules.push({ message: '请填写数字', validator: this.regularCheck(/^[0-9]+.?[0-9]*$/) })
            } else if (element === '06') {
              rules.push({ message: '请填写手机号码', validator: this.regularCheck(/^[1][3,4,5,7,8][0-9]{9}$/) })
            } else if (element === '07') {
              rules.push({ message: '请填写IMED', validator: this.regularCheck(/^[1][3,4,5,7,8][0-9]{9}$/) })
            } else if (element === '08') {
              rules.push({ message: '请填写IMEI' })
            } else if (element === '09') {
              rules.push({ message: '请填写身份证号码', validator: this.regularCheck(/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/) })
            } else if (element === '10') {
              rules.push({ message: '请输入姓名' })
            } else if (element === '11') {
              rules.push({ message: '数字符号' })
            } else if (element === '12') {
              rules.push({ message: '固定电话' })
            } else if (element === '13') {
              rules.push({ message: '手机或固定电话' })
            }
          })
          formValidateRuleData[property.name] = rules
        }
      })
      return formValidateRuleData
      // return {
      //   name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }]
      // }
    }
  },

  methods: {
    handleSelect(item) {
      console.log(item)
    },
    VType(item, type) {
      return type.indexOf(item.inputType) > -1
    },
    regularCheck(regular, message) {
      return (rule, value, callback) => {
        if (!value) {
          return true
        }
        if (!regular.test(value)) {
          return callback(new Error(message ? message : ''))
        } else {
          callback()
        }
      }
    }
  },
  watch: {
    formData: {
      immediate: true,
      handler(val, oldVal) {
        this.entityPropertys.forEach(element => {
          // 用来解决checkbox绑定数组问题
          if (element.inputType === '25' && !(this.formData[element.name] instanceof Array)) {
            this.$set(this.formData, element.name, [])
          }
        })
      }
    }
  }
}
</script>
<style scoped></style>
